export default __webpack_public_path__ + "help-center-header.jpg";